import * as yup from 'yup';
import { IncomeDTO, IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export interface UpsertIncomeDTO extends RealEstateFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
}

export interface RealEstateFormValues {
  associatedAssetId: string;
  amount: number | null;
  incomeGrowth: number | null;
  yearlyTaxableAmount: number | null;
  orionManagementStyleId: number | null;
  customBucketIndex: number | null;
}

const defaultValues = {
  associatedAssetId: '',
  amount: null,
  incomeGrowth: null,
  yearlyTaxableAmount: null,
  orionManagementStyleId: null,
  customBucketIndex: null,
};

export const dataToForm = (income: IncomeModel | null, data: IncomeDTO): RealEstateFormValues => {
  if (!income) {
    return defaultValues;
  }

  const { Options: options } = data;

  return {
    associatedAssetId: income.AssociatedAssetId,
    amount: income.Amount,
    incomeGrowth: income.IncomeGrowth,
    yearlyTaxableAmount: income.YearlyTaxableAmount,
    orionManagementStyleId: income.OrionManagementStyleId,
    customBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};

export const Validation = yup.object().shape({
  associatedAssetId: yup
    .string()
    .nullable()
    .required('Please specify an asset.'),
  amount: yup
    .number()
    .nullable()
    .required('Please specify a yearly amount'),
});
